import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';

export default class IndexRoute extends Route {
  @service billing;
  @service('stripev3') stripe;

  beforeModel() {
    this.route.replaceWith('settings.billing.your-plan');
    return this.stripe.load();
  }

  model(params) {
    // initialization of billing service returns an empty promise - actual data is available on service instance
    return this.billing.initialize({ refresh: true, paramPlanSlug: params.plan, code: params.code });
  }
}
